import React from 'react';
import styled, { css } from 'styled-components';
import { Phone } from '@styled-icons/material-outlined/Phone';
import { spacing, borderRadius } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text, TextVariant } from '@naf/text';
export const CallButton = ({
  variant = 'primary',
  withIcon = true,
  text,
  phoneNumberToCall
}) => {
  return /*#__PURE__*/React.createElement(StyledCallLink, {
    href: `tel:${phoneNumberToCall}`,
    $variant: variant,
    $withIcon: withIcon,
    role: "button",
    "aria-label": `Ring ${text}`
  }, withIcon && /*#__PURE__*/React.createElement(Phone, {
    size: "24px"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: TextVariant.Button
  }, text));
};
const StyledCallLink = styled.a.withConfig({
  displayName: "call-button__StyledCallLink",
  componentId: "sc-1grmzpf-0"
})(["display:flex;align-items:center;padding:", " ", ";border-radius:", ";font-size:1.125rem;font-weight:500;font-variant-numeric:lining-nums;width:fit-content;text-decoration:none;cursor:pointer;", " ", " ", ""], spacing.space16, spacing.space24, borderRadius.M, ({
  $variant
}) => $variant === 'primary' && css(["background-color:", ";color:", ";&:hover{background-color:", ";color:", ";}"], nafColor.signature.yellow, nafColor.signature.black, nafColor.signature.yellow40, nafColor.signature.black), ({
  $variant
}) => $variant === 'secondary' && css(["background-color:", ";color:", ";&:hover{background-color:", ";color:", ";}"], nafColor.primary.moss, nafColor.signature.black, nafColor.primary.kart, nafColor.signature.black), ({
  $withIcon
}) => $withIcon && css(["gap:", ";"], spacing.space8));
//# sourceMappingURL=call-button.js.map